var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row-reverse"},[_c('button',{staticClass:"focus-style",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeSelector()}}},[_vm._v("\n    X\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }